// vuex / store / mutations
// const MU_NAME = 'NU_NAME'
const SET_GAPI = 'SET_GAPI'
const SET_USER_EMAIL = 'SET_USER_EMAIL'
const ADD_USER_CACHES = 'ADD_USER_CACHES'
// # ms - new mutations
// ---------------------
const SET_MSAL = 'SET_MSAL'
const SET_ACCESS = 'SET_ACCESS'
// ---------------------

export default {
  // example:
  // [MU_NAME](state, data) {
  //   state.key = data.value
  // },
  [SET_GAPI] (state, data) {
    state.gapi = data
  },
  // # ms - update
  [SET_USER_EMAIL] (state, data) {
    state.user.email = data.email
    state.user.msId = data.msId
    state.user.Name = data.Name
    state.user.Avatar = data.Avatar
    state.user.Role = data.Role
    state.user.transfer_Role = data.transfer_Role == null ? null : String(data.transfer_Role)
    state.user.ci_Role = data.ci_Role
    state.user.bases_Role = data.bases_Role
    state.user.lock = data.lock
    // state.user.RoleType = data.RoleType
  },
  [ADD_USER_CACHES] (state, data) {
    if (!(data instanceof Object) || !data.email) { return }
    const index = state.userCaches.findIndex(el => el.email === data.email)
    if (index > 0) {
      for (const key in data) {
        state.userCaches[index][key] = data[key]
      }
    } else {
      state.userCaches.push(data)
    }
  },
  SET_BAR_IMAGE (state, payload) {
    state.barImage = payload
  },
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },

  // # ms - new mutations
  // ---------------------
  [SET_MSAL] (state, data) {
    data = data || null
    state.msal.app = data
  },
  [SET_ACCESS] (state, data) {
    data = data || {}
    state.msal.accessToken = data.accessToken || null
    state.msal.apiAccessToken = data.apiAccessToken || data.accessToken || null
    state.msal.graphToken = data.graphToken || data.accessToken || null
    state.msal.homeId = data.homeId || null
  }
  // ---------------------
}
